import axios from 'axios'
export class Api{
    baseUrl: string;
    token: string | null;
    additionalHeaders: {[key: string]: string} ;
    responseHistory: number[] = [];
    historyLength: number = 20;
    averageResponseTime: number = 0;
    constructor(baseUrl: string, token: string | null = null)
    {
        this.baseUrl = baseUrl;
        this.token = token;
        this.additionalHeaders = {};
    }
    setToken(token: string)
    {
        this.token = token;
    }
    addResponseTime(time: number)
    {
        this.responseHistory.push(time);
        if(this.responseHistory.length > this.historyLength)
        {
            this.responseHistory.shift();
        }
        let total = 0;
        for(const time of this.responseHistory)
        {
            total += time;
        }
        this.averageResponseTime = total / this.responseHistory.length;
    }
    addHeader(key: string, value: string)
    {
        this.additionalHeaders[key] = value;
    }
    getHeaders()
    {
        const headers = this.additionalHeaders;
        if(this.token != null)
        {
            headers['Authorization'] = `Bearer ${this.token}`;
        }

        // Debug logging in development
        if (process.env.NODE_ENV === 'development') {
            console.log('API Request Headers:', {
                hasToken: this.token != null,
                tokenPrefix: this.token ? this.token.substring(0, 10) + '...' : 'none',
                headers: headers
            });
        }

        return headers;
    }
    async get(path: string, queries: any = {}) {
        let url = this.baseUrl + path;
        let query = '';
        for(const key in queries)
        {
            query += `${key}=${queries[key]}&`;
        }
        if(query != '')
        {
            //remove last &
            query = query.substring(0, query.length - 1);
            url += `?${query}`;
        }
        const start = Date.now();
        const response = await axios.get(url, {headers: this.getHeaders()} )
        const end = Date.now();
        this.addResponseTime(end - start);
        return response
    }
    async post(path: string, data: any, queries: any = {}) {
        try
        {
            let url = this.baseUrl + path;
            let query = '';
            for(const key in queries)
            {
                query += `${key}=${queries[key]}&`;
            }
            if(query != '')
            {
                url += `?${query}`;
            }
            const start = Date.now();
            const response = await axios.post(url, data, {headers: this.getHeaders()} );
            const t = Date.now() - start;
            this.addResponseTime(t);
            return response
        }
        catch(error : any)
        {
            return error.response;
        }
    }
    async patch(path: string, data: any = null)
    {
        const response = await axios.patch(this.baseUrl + path, data, {headers: this.getHeaders()} );
        return response;
    }
    async put(path: string, data: any)
    {
        const start = Date.now();
        const response = await axios.put(this.baseUrl + path, data, {headers: this.getHeaders()} );
        const t = Date.now() - start;
        this.addResponseTime(t);
        return response;
    }


    async delete(path: string)
    {
        const response = await axios.delete(this.baseUrl + path, {headers: this.getHeaders()} );
        return response;
    }
    async submitFormData(path: string, data: any)
    {
        const response = await axios.post(this.baseUrl + path, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                ...this.getHeaders()
            }
        });
        return response;
    }
    async downloadFile(path: string)
    {
        const response = await axios.get(this.baseUrl + path, {
            headers: {
                ...this.getHeaders()
            },
            responseType: 'blob'
        });
        return response;
    }
    async download(path: string)
    {
        // Retrieve the token (assuming it's stored in local storage or in state)
        const fileUrl = this.baseUrl + path;
        let filename = ''
        fetch(fileUrl, {
            method: 'GET',
            headers: {
                ...this.getHeaders()
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const headers = response.headers;
            const contentDisposition = headers.get('content-disposition');
            const filenameMatch = contentDisposition && contentDisposition.match(/filename="(.+)"/);
            filename = filenameMatch ? filenameMatch[1] : 'download';
            return response.blob();
        })
        .then(blob => {
            // Create a URL for the blob
            const blobUrl = window.URL.createObjectURL(blob);
            // Create a temporary anchor element
            const anchor = document.createElement('a');
            anchor.href = blobUrl;
            anchor.download = filename; // You can set a filename here
            // Append anchor to body, click it, and then remove it
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            // Clean up by revoking the object URL
            window.URL.revokeObjectURL(blobUrl);
        })
        .catch(error => {
            console.error('Download error:', error);
        });
    }
    async downloadWithData(path: string, data: any)
    {
       axios.post(this.baseUrl + path, data, {
            headers: {
                ...this.getHeaders()
            },
            responseType: 'blob'
        })
        .then(response => {
            // Create a URL for the blob
            const blobUrl = window.URL.createObjectURL(response.data);
            const headers = response.headers;
            //getfilename
            const contentDisposition = headers['content-disposition'];
            const filenameMatch = contentDisposition && contentDisposition.match(/filename="(.+)"/);
            const filename = filenameMatch ? filenameMatch[1] : 'download';
            // Create a temporary anchor element
            const anchor = document.createElement('a');
            anchor.href = blobUrl;
            anchor.download = filename; // You can set a filename here
            // Append anchor to body, click it, and then remove it
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
            // Clean up by revoking the object URL
            window.URL.revokeObjectURL(blobUrl);
        })
        .catch(error => {
            console.error('Download error:', error);
        });
    }
}